import Layout from '../components/Layout';

export default function Captures() {
  return (
    <Layout>
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-xl shadow-lg p-6">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-2xl font-bold text-gray-800">All Captures</h2>
            <div className="flex gap-2">
              <select className="border-2 border-gray-200 rounded-lg px-4 py-2 focus:border-blue-600 focus:outline-none">
                <option>All Types</option>
                <option>Text</option>
                <option>Images</option>
                <option>Audio</option>
                <option>Video</option>
              </select>
              <select className="border-2 border-gray-200 rounded-lg px-4 py-2 focus:border-blue-600 focus:outline-none">
                <option>All Contexts</option>
                <option>Work</option>
                <option>Personal</option>
                <option>Events</option>
              </select>
            </div>
          </div>

          {/* Captures List */}
          <div className="space-y-4">
            <div className="border-2 border-gray-200 rounded-lg p-4 hover:border-blue-400 transition">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded">Text</span>
                    <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded">Work</span>
                    <span className="text-sm text-gray-500">2 hours ago</span>
                  </div>
                  <h3 className="font-semibold mb-1">Meeting Notes - Q1 Planning</h3>
                  <p className="text-sm text-gray-600">Discussed project timeline, resource allocation, and key deliverables...</p>
                </div>
                <button className="text-gray-400 hover:text-gray-600">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
                  </svg>
                </button>
              </div>
            </div>

            <div className="border-2 border-gray-200 rounded-lg p-4 hover:border-blue-400 transition">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="bg-purple-100 text-purple-800 text-xs px-2 py-1 rounded">Image</span>
                    <span className="bg-yellow-100 text-yellow-800 text-xs px-2 py-1 rounded">Events</span>
                    <span className="text-sm text-gray-500">1 day ago</span>
                  </div>
                  <h3 className="font-semibold mb-1">Conference Badge - TechCon 2025</h3>
                  <p className="text-sm text-gray-600">Scanned badge with contact information and session schedule</p>
                </div>
                <button className="text-gray-400 hover:text-gray-600">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
